export const readAsBase64 = (array: Uint8Array): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(new Blob([array]));
        reader.onload = () => resolve((<string>reader.result).split(",", 2)[1]);
        reader.onerror = error => reject(error);
    });
}
